import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Form, Col } from 'react-bootstrap'

const PoiTypeSelect = ({ poiTypes, selectedPoiType, onChange }) => {
  useEffect(() => {
    if (!selectedPoiType && poiTypes.length > 0) {
      onChange(poiTypes[0].name)
    }
  }, [poiTypes, onChange, selectedPoiType])

  const handleSelectChange = (event) => {
    if (onChange) {
      onChange(event.target.value)
    }
  }

  return (
    <Form.Group as={Col} controlId="typeSelect">
      <Form.Label>Type de POI</Form.Label>
      <Form.Control
        as="select"
        value={selectedPoiType}
        onChange={handleSelectChange}
      >
        {poiTypes.map((option) => (
          <option key={option.name} value={option.name}>
            {option.labelFr}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  )
}

PoiTypeSelect.propTypes = {
  poiTypes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      labelFr: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedPoiType: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default PoiTypeSelect
